import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useMultiBroadcast = () => {
  const { user } = useGetParams();
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const messagesRef = useRef([]);

  const protocol = window?.location.protocol || 'https:';

  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const getMultiBroadcastInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          setShowedMessages([]);
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }
      // Определяем состояние (S1, S2 ...)

      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // если имеются в списке сообщений удаленные
      if (
        messagesRef.current.some((el) =>
          deletedMessagesIdList.includes(Number(el.id)),
        )
      ) {
        messagesRef.current = messagesRef.current.filter(
          (el) => !deletedMessagesIdList.includes(Number(el.id)),
        );
      }

      // Удаляем сообщения, если они не содержат текста или вложения.
      messagesList = messagesList.filter(
        (el) =>
          (Array.isArray(el.message.attachments) &&
            el.message.attachments.length > 0) ||
          el.message.content !== '',
      );

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов

      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      const result = [...messagesRef.current, ...messagesList.reverse()];

      messagesRef.current = result;
      setShowedMessages(messagesRef.current);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMultiBroadcastInfo();
  }, []);

  // Получение информации о титре
  useInterval(getMultiBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    showedMessages,
  };
};
